import { IImageSectionModel } from 'Types/Litium';

import PartnerSectionImage from 'Components/Footer/PartnerSectionImage';

const PartnerSection = ({
    partnerSection,
}: {
    partnerSection: IImageSectionModel[];
}) => (
    <ul className="flex w-full flex-wrap justify-center gap-3 px-4.5 pb-8 pt-3 lg:px-0">
        {partnerSection.map((item, index) => (
            <li key={index}>
                {item?.linkUrl?.length > 0 ? (
                    <a
                        href={item.linkUrl}
                        className="font-montserrat text-sm"
                        aria-label={item.image.altText}
                    >
                        <PartnerSectionImage image={item.image} />
                    </a>
                ) : (
                    <div className="font-montserrat text-sm">
                        <PartnerSectionImage image={item.image} />
                    </div>
                )}
            </li>
        ))}
    </ul>
);

export default PartnerSection;
